"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmSceneSequence
 * @author xlongjiang
 * @created 2025-11-03 07:20:50
 */
const TabPanel = _tpmProductIntl.Tab.TabPanel;

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmSceneSequenceData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$itemList = _ref.itemList,
    itemList = _ref$itemList === void 0 ? [] : _ref$itemList;
  const handledItemsList = itemList.map((item, index) => {
    const _item$text = item.text,
      text = _item$text === void 0 ? '' : _item$text,
      _item$img = item.img,
      img = _item$img === void 0 ? '' : _item$img,
      _item$previewImg = item.previewImg,
      previewImg = _item$previewImg === void 0 ? '' : _item$previewImg,
      _item$video = item.video,
      video = _item$video === void 0 ? '' : _item$video,
      _item$videoPopup = item.videoPopup,
      videoPopup = _item$videoPopup === void 0 ? false : _item$videoPopup,
      _item$imgPosition = item.imgPosition,
      imgPosition = _item$imgPosition === void 0 ? 'left' : _item$imgPosition,
      _item$title = item.title,
      title = _item$title === void 0 ? '' : _item$title,
      _item$desc = item.desc,
      desc = _item$desc === void 0 ? '' : _item$desc,
      _item$listType = item.listType,
      listType = _item$listType === void 0 ? 'default' : _item$listType,
      _item$list = item.list,
      list = _item$list === void 0 ? [] : _item$list,
      _item$recommendTitle = item.recommendTitle,
      recommendTitle = _item$recommendTitle === void 0 ? '' : _item$recommendTitle,
      _item$recommendList = item.recommendList,
      recommendList = _item$recommendList === void 0 ? [] : _item$recommendList,
      _item$linkText = item.linkText,
      linkText = _item$linkText === void 0 ? '' : _item$linkText,
      _item$linkHref = item.linkHref,
      linkHref = _item$linkHref === void 0 ? '' : _item$linkHref;
    const linkExtendProps = {
      'report-event': 'click_SceneSequence_link',
      'report-ext1': index,
      'report-ext2': linkText || '',
      'report-ext3': linkHref || '',
      target: '_blank'
    };
    const handleList = list.map((item, key) => {
      const title = item.title,
        desc = item.desc,
        linkText = item.linkText,
        linkHref = item.linkHref;
      const linkExtendProps = {
        'report-event': 'click_SceneSequence_list_link',
        'report-ext1': index,
        'report-ext2': key,
        'report-ext3': linkText || '',
        target: '_blank'
      };
      return {
        title: title || '',
        desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
          html: desc
        }) : '',
        link: linkText && linkHref ? /*#__PURE__*/React.createElement(_tpmProductIntl.Link, Object.assign({
          href: linkHref
        }, linkExtendProps), linkText) : null
      };
    });
    const handleRecommend = recommendList.map((item, key) => {
      const text = item.text,
        href = item.href;
      const linkExtendProps = {
        'report-event': 'click_SceneSequence_recommend_link',
        'report-ext1': index,
        'report-ext2': key || '',
        'report-ext3': text || '',
        target: '_blank'
      };
      return _objectSpread({
        text,
        href
      }, linkExtendProps);
    });
    return {
      text,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      previewImg: (0, _componentUtils.doComponentsUploadEvent)(previewImg || '').url,
      video: (0, _componentUtils.doComponentsUploadEvent)(video || '').url,
      videoPopup,
      imgPosition,
      title: title || '',
      desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: desc
      }) : '',
      listType,
      list: !!list.length ? handleList : null,
      recommend: recommendTitle || !!recommendList.length ? {
        title: recommendTitle || '',
        data: !!recommendList.length ? handleRecommend : null
      } : null,
      link: linkHref && linkText ? /*#__PURE__*/React.createElement(_tpmProductIntl.Link, Object.assign({
        href: linkHref,
        icon: true
      }, linkExtendProps), linkText) : null
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    itemList: handledItemsList
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmSceneSequen = formatTpmSceneSequenceData(data, {
        domains
      }),
      porintId = _formatTpmSceneSequen.porintId,
      tag = _formatTpmSceneSequen.tag,
      title = _formatTpmSceneSequen.title,
      desc = _formatTpmSceneSequen.desc,
      bg = _formatTpmSceneSequen.bg,
      bgColor = _formatTpmSceneSequen.bgColor,
      bgImg = _formatTpmSceneSequen.bgImg,
      itemList = _formatTpmSceneSequen.itemList;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmSceneSequence`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmSceneSequence', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg
    }, itemList.length > 1 ? /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: itemList.map((item, index) => ({
        text: item.text,
        id: `id${index}`
      }))
    }, itemList.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: `id${index}`,
      key: index
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.SceneSequence, item)))) : itemList.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.SceneSequence, Object.assign({}, item, {
      key: index
    })))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}